import React from 'react'
import Link from 'next/link'
import { Article } from './index'
import { ArticleDate } from './article-date'

export interface ArticleCardHorizontalProps extends Article {
  reversed?: boolean
}
export const ArticleCardHorizontal = ({
  title,
  summary,
  mainImage,
  reversed = false,
  url,
  categoryName,
  tags,
  postDateText,
}: ArticleCardHorizontalProps) => {
  return (
    <article
      className={`c-article-card-horizontal ${
        reversed ? 'c-article-card-horizontal_reversed' : ''
      }`}>
      <Link prefetch={false} href={url} className="c-article-card-horizontal__link">
        {mainImage?.url ? (
          <div className="c-article-card-horizontal__image-wrap">
            <img
              className="c-article-card-horizontal__image"
              src={mainImage?.url}
              role="presentation"
              alt={title || categoryName || 'article image'}
            />
          </div>
        ) : null}
        <div className="c-article-card-horizontal__content">
          {categoryName && (
            <div className="c-article-card-horizontal__category">{categoryName}</div>
          )}
          {title ? <h3 className="c-article-card-horizontal__title h3">{title}</h3> : null}
          {summary ? <p className="c-article-card-horizontal__description">{summary}</p> : null}
          <footer className="c-article-card-horizontal__footer">
            {tags && tags.length > 0 && (
              <ul className="c-article-card-horizontal__tags">
                {tags.map((tag, i) =>
                  tag.name ? (
                    <li className="c-article-card-horizontal__tag" key={tag.name + i}>
                      {tag.url ? (
                        <Link prefetch={false} href={tag.url}>
                          {tag.name}
                        </Link>
                      ) : (
                        <span>{tag.name}</span>
                      )}
                    </li>
                  ) : null
                )}
              </ul>
            )}
            <ArticleDate isoDate={postDateText} className="c-article-card-horizontal__date" />
          </footer>
        </div>
      </Link>
    </article>
  )
}
